var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconToolBarNameGenerator(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Icon_ToolBar_NameGenerator"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 166",
    x: 3,
    y: 11.3182,
    width: 55,
    height: 38.3636,
    rx: 3,
    stroke: "#FEDE79",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.1018 30.5C18.6721 30.5 17.4482 29.957 16.4301 28.871C15.412 27.785 14.903 26.4795 14.903 24.9545C14.903 23.4295 15.412 22.124 16.4301 21.038C17.4482 19.9521 18.6721 19.4091 20.1018 19.4091C21.5315 19.4091 22.7554 19.9521 23.7735 21.038C24.7916 22.124 25.3007 23.4295 25.3007 24.9545C25.3007 26.4795 24.7916 27.785 23.7735 28.871C22.7554 29.957 21.5315 30.5 20.1018 30.5ZM12.3035 41.5909C11.5887 41.5909 10.9765 41.3191 10.467 40.7757C9.95755 40.2322 9.70324 39.5797 9.7041 38.8181V37.7091C9.7041 36.9235 9.89386 36.2012 10.2734 35.5422C10.6529 34.8832 11.1563 34.3809 11.7836 34.0352C13.1267 33.3189 14.4914 32.7815 15.8778 32.4229C17.2641 32.0642 18.6721 31.8854 20.1018 31.8863C21.5315 31.8863 22.9395 32.0656 24.3259 32.4242C25.7123 32.7828 27.077 33.3198 28.42 34.0352C29.0482 34.3818 29.5521 34.8846 29.9316 35.5436C30.3111 36.2025 30.5004 36.9244 30.4996 37.7091V38.8181C30.4996 39.5806 30.2448 40.2336 29.7353 40.7771C29.2258 41.3205 28.6141 41.5918 27.9001 41.5909H12.3035Z",
    fill: "#FEDE79"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 89",
    x1: 34.6592,
    y1: 21.9546,
    x2: 45.7501,
    y2: 21.9546,
    stroke: "#FEDE79",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 90",
    x1: 34.6592,
    y1: 30.2727,
    x2: 51.2955,
    y2: 30.2727,
    stroke: "#FEDE79",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 91",
    x1: 34.6592,
    y1: 38.5909,
    x2: 51.2955,
    y2: 38.5909,
    stroke: "#FEDE79",
    strokeWidth: 6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToolBarNameGenerator);
export default __webpack_public_path__ + "static/media/Icon_ToolBar_NameGenerator.c1bc2b20b2ebed438f18cdf348839a26.svg";
export { ForwardRef as ReactComponent };